"use client"

import { Hammer } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HammerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HammerIcon = component(Icon)({ as: Hammer })
